export type ThemeSizesTypes = "xs" | "sm" | "md" | "lg" | "xl";

export interface ThemeSizes {
  xs: any;
  sm: any;
  md: any;
  lg: any;
  xl: any;
}

export const isSizeType = (value: any): boolean => {
  if (
    value === "xs" ||
    value === "sm" ||
    value === "md" ||
    value === "lg" ||
    value === "xl"
  ) {
    return true;
  } else {
    return false;
  }
};

export const getSizeTypeBefore = (value: ThemeSizesTypes): ThemeSizesTypes => {
  if (value === "xl") {
    return "lg";
  }

  if (value === "lg") {
    return "md";
  }

  if (value === "md") {
    return "sm";
  }

  return "xs";
};
